var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessPurchase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 652,
    height: 570.125,
    viewBox: "0 0 652 570.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.955,670.8c-21.42,11.55-30.615,36.063-30.615,36.063s25.533,5.787,46.953-5.763,30.615-36.063,30.615-36.063S405.375,659.255,383.955,670.8Z",
    transform: "translate(-274 -164.937)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,678.744c-12.546,20.852-37.464,28.883-37.464,28.883S348.959,681.85,361.5,661s37.464-28.883,37.464-28.883S403.548,657.892,391,678.744Z",
    transform: "translate(-274 -164.937)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 45,
    transform: "translate(437.445 40.125)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.152,212.319H596.968V198.655a19.592,19.592,0,0,1,39.184,0Zm-38.317-.868h37.449v-12.8a18.725,18.725,0,1,0-37.449,0Z",
    transform: "translate(-274 -164.937)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.527,45.5v-5.34l-99.65,2.67-3.154,135.26,14.748,18.218Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.167,43.622,291.158,46.08l2.313,150.23L397.7,185.075Z",
    fill: "#f9af4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,530.355h-12.26L472.9,483.067H491Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.123,707.176H728.592v-.5a15.387,15.387,0,0,1,15.385-15.386h24.147Z",
    transform: "translate(-274 -164.937)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,530.355h-12.26L427.9,483.067H446Z",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.123,707.176H683.592v-.5a15.387,15.387,0,0,1,15.385-15.386h24.147Z",
    transform: "translate(-274 -164.937)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.992,399.2s-17.912,38.575-1.73,116.22S698.578,678.3,698.578,678.3l24.744.4,13.9-183.52,7.278,180.93h24.378l21.484-178.069s14.138-79.513-17.39-93.75Z",
    transform: "translate(-274 -164.937)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.733,263.063l-54.178-4.994h0c-16.99,12.384-26.525,34.625-24.568,57.574,2.654,31.115,1.756,73.934-19.542,92.536,0,0,58.049,45.816,109.615,2.35,0,0-17.633-47.238-5.526-66.1S792.007,272.563,769.733,263.063Z",
    transform: "translate(-274 -164.937)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.527,186.179a10.743,10.743,0,0,0,11.44,11.852L691.5,264.789l12.821-19.53-74.346-59.48a10.8,10.8,0,0,0-21.448.4Z",
    transform: "translate(-274 -164.937)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.142,254.476l16.97-17.432a4.817,4.817,0,0,1,7.281.438L717.1,256.765a13.377,13.377,0,1,1-18.719,19.116l-19.61-14.138a4.817,4.817,0,0,1-.633-7.266Z",
    transform: "translate(-274 -164.937)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.284,348.749a10.743,10.743,0,0,0-12.081-11.2l-75.132-62.68-11.716,20.212,77.536,55.257a10.8,10.8,0,0,0,21.392-1.59Z",
    transform: "translate(-274 -164.937)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.982,284.425l-15.975,18.348a4.817,4.817,0,0,1-7.294-.033L761.952,284.3a13.377,13.377,0,1,1,17.628-20.126L799.946,277.2a4.817,4.817,0,0,1,1.036,7.22Z",
    transform: "translate(-274 -164.937)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.918,375.253H852.237V364.9a14.841,14.841,0,0,1,29.681,0Zm-29.024-.657h28.367V364.9a14.183,14.183,0,1,0-28.367,0Z",
    transform: "translate(-274 -164.937)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594,208.892v-4.045l-75.482,2.023-2.389,102.455,11.171,13.8Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.956,207.468l-81.814,1.862,1.752,113.795,78.955-8.51Z",
    fill: "#f9af4c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(440.445 20.125)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.712,202.8c11.07,10.848,30.334,11.888,42.508,2.294a71.784,71.784,0,0,1-15.288,67.676c6.772,2.447,14.567.837,20.62-3.063s10.535-9.854,13.918-16.21c8.374-15.735,10.47-34.947,4.546-51.758s-20.117-30.75-37.36-35.264-37.014,1.062-48.534,14.663c-12.047,14.222-14,35.061-8.719,52.936s16.857,33.226,29.579,46.847a195.466,195.466,0,0,1-12.055-48.9c-.647-5.737-1.025-11.651.6-17.193s5.61-10.7,11.17-12.26",
    transform: "translate(-274 -164.937)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925,709.063H544a1,1,0,0,1,0-2H925a1,1,0,0,1,0,2Z",
    transform: "translate(-274 -164.937)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,709.063H275a1,1,0,0,1,0-2H437a1,1,0,0,1,0,2Z",
    transform: "translate(-274 -164.937)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.918,622.253H836.237V611.9a14.841,14.841,0,0,1,29.681,0Zm-29.024-.657h28.367V611.9a14.183,14.183,0,0,0-28.367,0Z",
    transform: "translate(-274 -164.937)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.594,455.892v-4.045l-75.482,2.023-2.389,102.455,11.171,13.8Z",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.956,454.468l-81.814,1.862,1.752,113.8,78.955-8.51Z",
    fill: "#fbd090"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPurchase);
export default __webpack_public_path__ + "static/media/success_purchase.c4f5bcf1e33310fa32b073de06b0a601.svg";
export { ForwardRef as ReactComponent };